export const url_languages_id = 'languages/:languageId'
export const url_settings = 'settings'
export const url_settings_actions = 'settings/actions'
export const url_settings_departments = 'settings/departments'
export const url_settings_departments_id = 'settings/departments/:departmentId'
export const url_settings_divisions = 'settings/divisions'
export const url_settings_divisions_id = 'settings/divisions/:divisionId'
export const url_settings_divisions_id_locations = 'settings/divisions/:divisionId/locations'
export const url_settings_general = 'settings/general'
export const url_settings_languages = 'settings/languages'
export const url_settings_languages_id = 'settings/languages/:languageId'
export const url_settings_locations = 'settings/locations'
export const url_settings_locations_id = 'settings/locations/:locationId'
export const url_settings_manuals = 'settings/manuals'
export const url_settings_registrations = 'settings/registrations'
export const url_settings_roles = 'settings/roles'
export const url_settings_sensory = 'settings/sensory'
export const url_settings_suppliersmanagement = 'settings/suppliers_management'
export const url_settings_tiles = 'settings/tiles'
export const url_settings_users_id = 'settings/users/:userId'
export const url_settings_usertypes = 'settings/user-types'
export const url_settings_usertypes_id_permissions = 'settings/user-types/:userTypeId/permissions'
export const url_settings_usertypes_id_roles = 'settings/user-types/:userTypeId/roles'
